import { useAuthority } from "../../../../../../../utils/hook/useAuthority"

export const useVariablesAuthority = () => {
  const { isCommonRefer } = useAuthority()

  return {
    isCommonRefer,
  }
}
